import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { TranslatePipe } from "../translate/translate.pipe";

@Injectable()
export class BrowserTitleService {

	constructor(
		private translatePipe: TranslatePipe,
		private titleService: Title
	) { }

	public setTitle(value: string) {
		const prefix = this.translatePipe.transform(value, []);
		const suffix = this.translatePipe.transform("application.title", []);
		this.titleService.setTitle(`${prefix} - ${suffix}`);
	}

}
